require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-2018-12-06-le-scalpel-du-xxie-siecle.json") })
        }
      }, "path---news-2018-12-06-le-scalpel-du-xxie-siecle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-2018-12-06-le-scalpel-du-xxie-siecle!./.cache/json/news-2018-12-06-le-scalpel-du-xxie-siecle.json
// module id = 470
// module chunks = 231608221292675